import { useEffect, useState } from 'react';

const DebugInfo = () => {
  const [debugInfo, setDebugInfo] = useState({});
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    
    // Only run on client side
    if (typeof window === 'undefined') return;
    
    // Collect debug information
    const info = {
      userAgent: navigator?.userAgent || 'Unknown',
      timestamp: new Date().toISOString(),
      url: window?.location?.href || 'Unknown',
      environment: {
        NODE_ENV: process.env.NODE_ENV,
        VERCEL_ENV: process.env.VERCEL_ENV,
        NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV
      },
      localStorage: {
        hasStorage: typeof localStorage !== 'undefined',
        keys: typeof localStorage !== 'undefined' ? Object.keys(localStorage) : []
      },
      sessionStorage: {
        hasStorage: typeof sessionStorage !== 'undefined',
        keys: typeof sessionStorage !== 'undefined' ? Object.keys(sessionStorage) : []
      },
      network: {
        online: navigator?.onLine || false,
        connection: navigator?.connection ? {
          effectiveType: navigator.connection.effectiveType,
          downlink: navigator.connection.downlink,
          rtt: navigator.connection.rtt
        } : null
      },
      screen: {
        width: window?.screen?.width || 0,
        height: window?.screen?.height || 0,
        devicePixelRatio: window?.devicePixelRatio || 1
      }
    };
    
    setDebugInfo(info);
    console.log('[DebugInfo] Environment details:', info);
  }, []);

  // Only show in development or when explicitly enabled
  const shouldShow = isClient && (
    process.env.NODE_ENV === 'development' || 
    process.env.VERCEL_ENV || 
    (typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('debug'))
  );

  if (!isClient || !shouldShow) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm">
      <details className="bg-black bg-opacity-80 text-white text-xs p-3 rounded-lg shadow-lg">
        <summary className="cursor-pointer font-bold text-yellow-300">
          🐛 Debug Info
        </summary>
        <div className="mt-2 space-y-2">
          <div>
            <strong>Environment:</strong> {debugInfo.environment?.NODE_ENV || 'unknown'}
          </div>
          <div>
            <strong>Vercel Env:</strong> {debugInfo.environment?.VERCEL_ENV || 'local'}
          </div>
          <div>
            <strong>Network:</strong> {debugInfo.network?.online ? 'Online' : 'Offline'}
          </div>
          <div>
            <strong>Time:</strong> {debugInfo.timestamp?.split('T')[1]?.split('.')[0]}
          </div>
          <div>
            <strong>URL:</strong> 
            <div className="font-mono text-xs break-all">
              {debugInfo.url}
            </div>
          </div>
        </div>
      </details>
    </div>
  );
};

export default DebugInfo;
